export const CLIENT_NOTES_STATE_IS_LOADING = 'CLIENT_NOTES_STATE_IS_LOADING';
